import { render, staticRenderFns } from "./InvestorsWalletTab.vue?vue&type=template&id=d6a950f6&scoped=true"
import script from "./InvestorsWalletTab.vue?vue&type=script&lang=js"
export * from "./InvestorsWalletTab.vue?vue&type=script&lang=js"
import style0 from "./InvestorsWalletTab.vue?vue&type=style&index=0&id=d6a950f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a950f6",
  null
  
)

export default component.exports